import React from 'react';

const PlayIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21 12C21 16.971 16.971 21 12 21C7.029 21 3 16.971 3 12C3 7.029 7.029 3 12 3C16.971 3 21 7.029 21 12Z"
      fill="#D5DAF3"
    />
    <path
      d="M10.9406 9.05685L14.8226 11.3528C15.3136 11.6428 15.3136 12.3538 14.8226 12.6438L10.9406 14.9398C10.4406 15.2358 9.80859 14.8748 9.80859 14.2938V9.70285C9.80859 9.12185 10.4406 8.76085 10.9406 9.05685Z"
      fill="#2D46C1"
    />
  </svg>
);

export default PlayIcon;
